const IE9_AJAX_SUCCESS_STATUS_CODE = 1223;

export function normaliseIEStatusCode(statusCode) {
    return (statusCode === IE9_AJAX_SUCCESS_STATUS_CODE) ? 204 : statusCode;
}

export function isHttpSuccess(statusCode) {
    return (statusCode >= 200 && statusCode < 300) || statusCode === IE9_AJAX_SUCCESS_STATUS_CODE;
}




/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/httpUtils.js
 **/